// Aurea Luxe — theme JS

document.documentElement.classList.replace('no-js', 'js');

// ---- Preserve collection scroll position on Back navigation ----
// Save scroll position when leaving a collection/search page via a product card click.
// Restore the position when that page loads again (back/forward navigation).
const SCROLL_KEY = (path) => `al:scroll:${path}`;
document.addEventListener('click', (e) => {
  const card = e.target.closest('a.product-card');
  if (!card) return;
  // Only save on listing pages (anything but the product itself)
  if (!/\/products\//.test(location.pathname)) {
    try { sessionStorage.setItem(SCROLL_KEY(location.pathname), String(window.scrollY)); } catch {}
  }
});
window.addEventListener('pageshow', () => {
  const key = SCROLL_KEY(location.pathname);
  let saved = null;
  try { saved = sessionStorage.getItem(key); } catch {}
  if (saved == null) return;
  const y = parseInt(saved, 10) || 0;
  // Restore after a tick so the layout (and Lenis) is ready.
  const apply = () => {
    if (window.__lenis) window.__lenis.scrollTo(y, { immediate: true });
    else window.scrollTo({ top: y, behavior: 'instant' });
  };
  requestAnimationFrame(() => requestAnimationFrame(apply));
  try { sessionStorage.removeItem(key); } catch {}
});

// ---- Haptic feedback (Android + supported browsers) ----
// Light vibrate on any interactive button-like element. iOS won't fire but
// no harm — and Android gives that real "premium app" tap feel.
// Fire on pointerDOWN (not click) so the buzz lands the instant the finger
// touches — same as the noon app. Crisp 10ms tick, not a long buzz.
document.addEventListener('pointerdown', (e) => {
  if (e.pointerType === 'mouse') return; // desktop mouse: no haptic hardware
  const target = e.target.closest(
    '.btn, .btn-ghost, .pdp__option-btn, .qty-btn, .icon-btn, .cart-item__remove, .product-card, .nav-primary a, .burger, .al-search-chip, .pagination a, .search-overlay__submit, .search-overlay__close, .al-intro__skip, #rsi_buy_now_button, .releasit-cod-form-button, [id*="rsi_buy_now"], [data-action], [data-open-cart], [data-close-cart], [data-open-search], [data-close-search]'
  );
  if (target && 'vibrate' in navigator) {
    try { navigator.vibrate(10); } catch {}
  }
}, { capture: true });

// ---- Lenis smooth scroll (brand signature) ----
window.addEventListener('DOMContentLoaded', () => {
  if (typeof Lenis !== 'undefined') {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      lerp: 0.1,
      // Don't hijack scroll inside drawers / modals / native-scroll panes
      prevent: (node) => !!(node && node.closest && node.closest('[data-lenis-prevent]')),
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    window.__lenis = lenis;
  }
  if (typeof lucide !== 'undefined') lucide.createIcons();
});

// ---- Sticky header blur on scroll ----
window.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  header.classList.toggle('scrolled', window.scrollY > 80);
}, { passive: true });

// ---- Mobile burger menu — right-side slide-in drawer ----
(function(){
  var backdrop = null;
  function ensureBackdrop(){
    if(backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'nav-backdrop';
    backdrop.setAttribute('aria-hidden','true');
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', closeNav);
    return backdrop;
  }
  function openNav(){
    var nav = document.querySelector('.nav-primary');
    if(!nav) return;
    ensureBackdrop();
    // force reflow so transition runs from off-screen every time
    nav.classList.add('is-mounted');
    void nav.offsetWidth;
    requestAnimationFrame(function(){
      nav.classList.add('open');
      backdrop.classList.add('open');
      document.body.classList.add('nav-open');
    });
  }
  function closeNav(){
    var nav = document.querySelector('.nav-primary');
    if(!nav) return;
    nav.classList.remove('open');
    if(backdrop) backdrop.classList.remove('open');
    document.body.classList.remove('nav-open');
    // unmount after transition so it can't be tabbed to
    setTimeout(function(){ nav.classList.remove('is-mounted'); }, 500);
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('.burger')){
      e.preventDefault();
      var nav = document.querySelector('.nav-primary');
      if(nav && nav.classList.contains('open')) closeNav(); else openNav();
      return;
    }
    // Close when a nav link is tapped
    if(e.target.closest('.nav-primary a')) closeNav();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeNav(); });
})();

// ---- Search overlay (predictive) ----
const openSearch = () => {
  const ov = document.querySelector('[data-search-overlay]');
  if (!ov) return;
  ov.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => document.querySelector('[data-search-input]')?.focus(), 50);
};
const closeSearch = () => {
  const ov = document.querySelector('[data-search-overlay]');
  if (!ov) return;
  ov.classList.remove('open');
  document.body.style.overflow = '';
};
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); }
  if (e.target.closest('[data-close-search]')) {
    // Two-step X: first click clears text, second click closes overlay
    const inp = document.querySelector('[data-search-input]');
    if (inp && inp.value.trim().length > 0) {
      inp.value = '';
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      inp.focus();
    } else {
      closeSearch();
    }
  }
  // Click outside form closes
  const ov = document.querySelector('[data-search-overlay].open');
  if (ov && e.target === ov) closeSearch();
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeSearch();
});

// Predictive search: live results as you type — WITH live filters (brand / category / concentration / price)
let searchTimer;
let searchSeq = 0;
let searchController = null;
let alLastProducts = [];   // last fetched product set (unfiltered)
const alSearchFilters = { brand:new Set(), gender:new Set(), conc:new Set(), priceMin:null, priceMax:null, priceKey:null };

function alDeriveConc(title){
  const t = (title||'').toLowerCase();
  if (t.includes('eau de parfum')) return 'EDP';
  if (t.includes('eau de toilette')) return 'EDT';
  if (t.includes('eau de cologne')) return 'Cologne';
  if (/\bedp\b/.test(t)) return 'EDP';
  if (/\bedt\b/.test(t)) return 'EDT';
  if (t.includes('elixir')) return 'Elixir';
  if (t.includes('parfum')) return 'Parfum';
  if (t.includes('cologne')) return 'Cologne';
  return '';
}
function alDeriveGenders(tags){
  const out = [];
  (tags||[]).forEach(t=>{ const x=String(t).toLowerCase().trim(); if(x==='men'||x==='women'||x==='unisex') out.push(x); });
  return out;
}
function alProductBrand(p){ let b = p.product_type || p.vendor || ''; if(/^aurea\s*luxe$/i.test(b)) b=''; return b; }
function alProductPriceAED(p){ return p.price ? Math.round(parseFloat(p.price)) : 0; }

const AL_PRICE_BANDS = [
  { key:'0-200', label:'Under 200', min:0, max:200 },
  { key:'200-400', label:'200–400', min:200, max:400 },
  { key:'400-600', label:'400–600', min:400, max:600 },
  { key:'600-800', label:'600–800', min:600, max:800 },
  { key:'800-1200', label:'800–1200', min:800, max:1200 },
  { key:'1200+', label:'1200+', min:1200, max:1e9 }
];
let alFilterOpen = false;   // panel visibility, controlled by the Filter button
const AL_GEN_LABEL = { men:'Men', women:'Women', unisex:'Unisex' };

function alFilterProducts(list){ return alFilterExcept(list, null); }

// Apply all active filters EXCEPT one dimension (for facet-aware counts).
// except = 'brand' | 'gender' | 'conc' | 'price' | null (apply all).
function alFilterExcept(list, except){
  const f = alSearchFilters;
  return list.filter(p=>{
    const b = alProductBrand(p);
    const g = alDeriveGenders(p.tags);
    const c = alDeriveConc(p.title);
    const price = alProductPriceAED(p);
    if (except!=='brand'  && f.brand.size  && !f.brand.has(b)) return false;
    if (except!=='gender' && f.gender.size && !g.some(x=>f.gender.has(x))) return false;
    if (except!=='conc'   && f.conc.size   && !f.conc.has(c)) return false;
    if (except!=='price'  && f.priceKey!=null && !(price>=f.priceMin && price<f.priceMax)) return false;
    return true;
  });
}

let alSuggestProducts = [];   // last suggest.json results (typed search)
let alBrowseAll = null;       // cached full catalogue for filter-only browsing
let alBrowseLoading = false;

function alHasActiveFilters(){
  const f = alSearchFilters;
  return (f.brand.size + f.gender.size + f.conc.size + (f.priceKey!=null?1:0)) > 0;
}

// Fetch the whole catalogue once, mapped to the same shape the renderer uses.
async function alEnsureBrowseData(){
  if (alBrowseAll || alBrowseLoading) return;
  alBrowseLoading = true;
  try {
    let page = 1, all = [];
    while (page <= 4){   // up to 1000 products (store ~550)
      const r = await fetch(`/collections/all/products.json?limit=250&page=${page}`);
      const j = await r.json();
      const list = j.products || [];
      if (!list.length) break;
      list.forEach(p=>{
        let minPrice = Infinity, maxComp = 0;
        (p.variants||[]).forEach(v=>{
          const pr = parseFloat(v.price); if(!isNaN(pr)) minPrice = Math.min(minPrice, pr);
          const cp = v.compare_at_price ? parseFloat(v.compare_at_price) : 0; if(cp) maxComp = Math.max(maxComp, cp);
        });
        if (minPrice === Infinity) minPrice = 0;
        const img = (p.images && p.images[0]) ? p.images[0].src : '';
        all.push({
          title: p.title,
          url: '/products/' + p.handle,
          product_type: p.product_type || '',
          vendor: p.vendor || '',
          tags: p.tags || [],
          price: String(minPrice),
          compare_at_price_max: maxComp ? String(maxComp) : null,
          featured_image: img ? { url: img } : null
        });
      });
      if (list.length < 250) break;
      page++;
    }
    alBrowseAll = all;
  } catch(e){ alBrowseAll = []; }
  alBrowseLoading = false;
}

// Decide the working set (typed search vs filter-only browse) and render.
async function alApplyAndRender(){
  const input = document.querySelector('[data-search-input]');
  const q = (input ? input.value : '').trim();
  if (q.length >= 2){
    alLastProducts = alSuggestProducts;
  } else if (alHasActiveFilters()){
    const results = document.querySelector('[data-search-results]');
    if (results && !alBrowseAll){
      results.innerHTML = '<p style="grid-column:1/-1;color:var(--al-fg-quiet);font-size:12px;letter-spacing:0.18em;text-transform:uppercase;margin:0;">Loading…</p>';
    }
    await alEnsureBrowseData();
    alLastProducts = alBrowseAll || [];
  } else {
    alLastProducts = [];
  }
  alRenderFilterBar();
  alRenderResults();
}

function alUpdateFilterCount(){
  const f = alSearchFilters;
  const activeN = f.brand.size + f.gender.size + f.conc.size + (f.priceKey!=null?1:0);
  const badge = document.querySelector('[data-search-filter-count]');
  const btn = document.querySelector('[data-search-filter-toggle]');
  if (badge){ badge.textContent = activeN || ''; badge.hidden = activeN===0; }
  if (btn){ btn.classList.toggle('is-active', activeN>0 || alFilterOpen); }
  return activeN;
}

function alRenderFilterBar(){
  const bar = document.querySelector('[data-search-filters]');
  if (!bar) return;
  const f = alSearchFilters;
  // Brand + Type options: use the active result set if present, else the full
  // catalogue — so brands are visible the moment the panel opens.
  const optSource = (alLastProducts && alLastProducts.length) ? alLastProducts : (alBrowseAll || []);
  // Facet-aware counts: each facet reflects the OTHER active filters.
  const brands={}, concs={};
  alFilterExcept(optSource, 'brand').forEach(p=>{ const b=alProductBrand(p); if(b) brands[b]=(brands[b]||0)+1; });
  alFilterExcept(optSource, 'conc').forEach(p=>{ const c=alDeriveConc(p.title); if(c) concs[c]=(concs[c]||0)+1; });
  // prune brand/type selections no longer available (category/price are static)
  [...f.brand].forEach(v=>{ if(!brands[v]) f.brand.delete(v); });
  [...f.conc].forEach(v=>{ if(!concs[v]) f.conc.delete(v); });

  const activeN = alUpdateFilterCount();
  bar.hidden = !alFilterOpen;   // visibility controlled ONLY by the Filter button
  if (!alFilterOpen){ return; } // keep state but don't rebuild while closed

  let html = '';
  const chip = (label,count,on,attr)=>`<button type="button" class="al-chip${on?' is-on':''}" ${attr}>${label}${count?` <span class="al-chip__n">${count}</span>`:''}</button>`;

  // Clear — at the TOP
  if (activeN) html += `<div class="sof-row sof-row--clear"><button type="button" class="sof-clear" data-search-filter-clear>Clear all filters</button></div>`;

  // Category — ALWAYS all three
  html += `<div class="sof-row"><span class="sof-lab">Category</span>`;
  ['men','women','unisex'].forEach(g=> html += chip(AL_GEN_LABEL[g], '', f.gender.has(g), `data-fg="${g}"`));
  html += `</div>`;

  // Price — ALWAYS all bands
  html += `<div class="sof-row"><span class="sof-lab">Price</span>`;
  AL_PRICE_BANDS.forEach(band=> html += chip(band.label, '', f.priceKey===band.key, `data-fp="${band.key}"`));
  html += `</div>`;

  // Brand — SINGLE-SELECT. Once one is chosen, only that chip stays (others hide).
  let bKeys = Object.keys(brands).sort();
  if (f.brand.size){ bKeys = bKeys.filter(b=>f.brand.has(b)); }   // collapse to the picked brand
  if (bKeys.length){
    html += `<div class="sof-row"><span class="sof-lab">Brand</span>`;
    bKeys.forEach(b=> html += chip(b, brands[b], f.brand.has(b), `data-fb="${b.replace(/"/g,'&quot;')}"`));
    html += `</div>`;
  }
  // Type — dynamic
  const cKeys = ['EDP','EDT','Parfum','Cologne','Elixir'].filter(c=>concs[c]);
  if (cKeys.length){
    html += `<div class="sof-row"><span class="sof-lab">Type</span>`;
    cKeys.forEach(c=> html += chip(c, concs[c], f.conc.has(c), `data-fc="${c}"`));
    html += `</div>`;
  }
  bar.innerHTML = html;
}

function alRenderResults(){
  const results = document.querySelector('[data-search-results]');
  if (!results) return;
  const filtered = alFilterProducts(alLastProducts);
  if (alLastProducts.length && filtered.length === 0){
    results.innerHTML = '<p style="grid-column:1/-1;color:var(--al-fg-muted);font-size:14px;margin:0;">No matches for these filters. <button type="button" data-search-filter-clear style="background:none;border:0;color:var(--al-gold);text-decoration:underline;cursor:pointer;font:inherit;">Clear filters</button></p>';
    return;
  }
  const CAP = 60;
  const show = filtered.slice(0, CAP);
  const moreNote = filtered.length > CAP
    ? `<p style="grid-column:1/-1;color:var(--al-fg-quiet);font-size:12px;letter-spacing:0.14em;text-transform:uppercase;margin:6px 0 0;">Showing ${CAP} of ${filtered.length} — refine to narrow</p>`
    : '';
  results.innerHTML = show.map(p => {
    const brand = alProductBrand(p);
    const priceCents = p.price ? Math.round(parseFloat(p.price) * 100) : 0;
    const _cmp = p.compare_at_price_max || p.compare_at_price_min || p.compare_at_price;
    const compareCents = _cmp ? Math.round(parseFloat(_cmp) * 100) : 0;
    const priceTxt = formatMoney(priceCents, 'AED');
    const compareTxt = compareCents && compareCents > priceCents ? formatMoney(compareCents, 'AED') : '';
    const rawImg = p.featured_image?.url || '';
    const imgUrl = rawImg.replace(/(\.(jpe?g|png|webp|gif|avif)(?:\?|$))/i, '_600x600$1');
    return `
      <a href="${p.url}" class="product-card">
        <div class="product-card__image-wrap">
          ${imgUrl ? `<img class="product-card__image" src="${imgUrl}" alt="" loading="lazy">` : ''}
        </div>
        <div class="product-card__brand">AUREA LUXE${brand ? ` <span class="dot">•</span> <span class="brand-name">${brand}</span>` : ''}</div>
        <div class="product-card__name">${p.title}</div>
        <div class="product-card__price-row">
          <span class="product-card__price">${priceTxt}</span>
          ${compareTxt ? `<span class="product-card__price-was">${compareTxt}</span>` : ''}
        </div>
      </a>
    `;
  }).join('') + moreNote;
}

// chip clicks (delegated on the filter bar)
document.addEventListener('click', (e) => {
  const bar = e.target.closest('[data-search-filters]');
  const clearBtn = e.target.closest('[data-search-filter-clear]');
  if (clearBtn){
    alSearchFilters.brand.clear(); alSearchFilters.gender.clear(); alSearchFilters.conc.clear();
    alSearchFilters.priceKey=null; alSearchFilters.priceMin=null; alSearchFilters.priceMax=null;
    alApplyAndRender(); return;
  }
  if (!bar) return;
  const chip = e.target.closest('.al-chip');
  if (!chip) return;
  const f = alSearchFilters;
  if (chip.dataset.fb!=null){
    // single-select brand: re-clicking clears it, otherwise replace any prior brand
    if (f.brand.has(chip.dataset.fb)) { f.brand.clear(); }
    else { f.brand.clear(); f.brand.add(chip.dataset.fb); }
  }
  else if (chip.dataset.fg!=null){ f.gender.has(chip.dataset.fg)?f.gender.delete(chip.dataset.fg):f.gender.add(chip.dataset.fg); }
  else if (chip.dataset.fc!=null){ f.conc.has(chip.dataset.fc)?f.conc.delete(chip.dataset.fc):f.conc.add(chip.dataset.fc); }
  else if (chip.dataset.fp!=null){
    const band = AL_PRICE_BANDS.find(b=>b.key===chip.dataset.fp);
    if (f.priceKey===band.key){ f.priceKey=null; f.priceMin=null; f.priceMax=null; }
    else { f.priceKey=band.key; f.priceMin=band.min; f.priceMax=band.max; }
  }
  alApplyAndRender();
});

// Filter toggle button — opens/closes the filter panel
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-search-filter-toggle]');
  if (!btn) return;
  e.preventDefault();
  alFilterOpen = !alFilterOpen;
  btn.setAttribute('aria-expanded', alFilterOpen ? 'true' : 'false');
  if (alFilterOpen){
    alRenderFilterBar();                    // show Category + Price instantly
    if (alHasActiveFilters()){ alApplyAndRender(); }
    else if (!alBrowseAll){                 // preload catalogue so Brand/Type populate
      alEnsureBrowseData().then(alRenderFilterBar);
    }
  } else {
    alRenderFilterBar();
  }
});

document.addEventListener('input', (e) => {
  const input = e.target.closest('[data-search-input]');
  if (!input) return;
  clearTimeout(searchTimer);
  const q = input.value.trim();
  const results = document.querySelector('[data-search-results]');
  const bar = document.querySelector('[data-search-filters]');
  if (!results) return;
  if (q.length < 2) {
    if (searchController) { searchController.abort(); searchController = null; }
    alSuggestProducts = [];
    if (alHasActiveFilters()) { alApplyAndRender(); }   // filter-only browse
    else { alLastProducts = []; results.innerHTML = ''; alRenderFilterBar(); }
    return;
  }
  if (!results.querySelector('.product-card')) {
    results.innerHTML = '<p style="grid-column:1/-1;color:var(--al-fg-quiet);font-size:12px;letter-spacing:0.18em;text-transform:uppercase;margin:0;">Searching…</p>';
  }
  searchTimer = setTimeout(async () => {
    const seq = ++searchSeq;
    if (searchController) searchController.abort();
    searchController = new AbortController();
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor`;
      const r = await fetch(url, { signal: searchController.signal });
      const j = await r.json();
      if (seq !== searchSeq) return;
      const products = j.resources?.results?.products || [];
      alSuggestProducts = products;
      alLastProducts = products;
      if (products.length === 0 && !alHasActiveFilters()) {
        results.innerHTML = '<p style="color:var(--al-fg-muted);font-size:14px;">Nothing matched. Try a brand or a fragrance family.</p>';
        alRenderFilterBar();
        return;
      }
      alRenderFilterBar();
      alRenderResults();
    } catch (err) { if (err.name !== 'AbortError') console.error(err); }
  }, 240);
});

// ---- Cart drawer ----
const openCart = () => {
  document.querySelector('.cart-drawer')?.classList.add('open');
  document.querySelector('.cart-drawer__overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
};
const closeCart = () => {
  document.querySelector('.cart-drawer')?.classList.remove('open');
  document.querySelector('.cart-drawer__overlay')?.classList.remove('open');
  document.body.style.overflow = '';
};
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); refreshCart(); }
  if (e.target.closest('[data-close-cart]')) closeCart();
});

// ---- PDP single-option (Size) variant selector ----
// On size click: (1) flip active style, (2) update hidden variant_id input,
// (3) swap displayed price + compare-at to reflect the selected variant,
// (4) toggle Add-to-Basket disabled state based on availability.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.pdp__option-btn');
  if (!btn) return;
  const optionWrap = btn.closest('.pdp__option');
  if (!optionWrap) return;

  // 1) active state
  optionWrap.querySelectorAll('.pdp__option-btn').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');

  // 2) hidden variant id
  const variantId = btn.dataset.variantId;
  const input = document.querySelector('[data-variant-input]');
  if (input && variantId) input.value = variantId;

  // 3) update visible price + compare-at
  const priceEl = document.querySelector('[data-pdp-price]');
  const compareEl = document.querySelector('[data-pdp-compare]');
  if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
  if (compareEl) {
    const cmp = btn.dataset.compareAt || '';
    if (cmp) { compareEl.textContent = cmp; compareEl.removeAttribute('hidden'); }
    else { compareEl.textContent = ''; compareEl.setAttribute('hidden', ''); }
  }

  // 4) toggle Add-to-Basket button disabled state
  const submit = document.querySelector('.pdp__actions button[type="submit"]');
  if (submit) {
    const avail = btn.dataset.available === '1';
    submit.disabled = !avail;
    submit.textContent = avail ? 'Add to Basket' : 'Currently on the waiting list';
  }
});

// ---- Add to cart via Shopify Ajax API ----
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  e.preventDefault();
  const fd = new FormData(form);
  const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
  if (res.ok) {
    openCart();
    refreshCart();
  }
});

// ---- Refresh cart drawer contents ----
async function refreshCart() {
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  if (!res.ok) return;
  renderCart(await res.json());
  // Sync delivery toggle (visibility + ticked state) after refresh
  if (typeof window.__alDeliveryToggleSync === 'function') {
    try { window.__alDeliveryToggleSync(); } catch {}
  }
}
window.refreshCart = refreshCart;

// ---- Cart line quantity controls + remove (optimistic, single round-trip) ----
const inflight = new Map();          // key -> abortController (debounce per line)
const pendingQty = new Map();        // key -> latest desired qty
let suppressRenderUntil = 0;         // suppress full re-render while transitions run

async function applyCartChange(key, qty) {
  pendingQty.set(key, qty);
  inflight.get(key)?.abort();
  const ctrl = new AbortController();
  inflight.set(key, ctrl);
  try {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      signal: ctrl.signal,
    });
    if (!r.ok) throw new Error('cart change failed');
    let cart = await r.json();
    if (pendingQty.get(key) !== qty) return; // superseded

    // Auto-remove 24 Hours Delivery if it's the only item left
    const DELIVERY_VARIANT_ID = 42976083968098;
    const others = cart.items.filter(i => i.variant_id !== DELIVERY_VARIANT_ID);
    const deliveryLine = cart.items.find(i => i.variant_id === DELIVERY_VARIANT_ID);
    if (deliveryLine && others.length === 0) {
      const r2 = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: deliveryLine.key, quantity: 0 }),
      });
      if (r2.ok) cart = await r2.json();
      // Visually un-tick all delivery toggles
      document.querySelectorAll('[data-delivery-toggle]').forEach(b => {
        b.classList.remove('is-on');
        b.setAttribute('aria-pressed', 'false');
      });
    }

    const now = performance.now();
    const wait = Math.max(0, suppressRenderUntil - now);
    if (wait > 0) setTimeout(() => renderCart(cart), wait);
    else renderCart(cart);
    // Re-sync delivery toggle visibility/state after any cart change
    if (typeof window.__alDeliveryToggleSync === 'function') {
      try { window.__alDeliveryToggleSync(); } catch {}
    }
    inflight.delete(key);
    pendingQty.delete(key);
  } catch (err) {
    if (err.name !== 'AbortError') console.error(err);
  }
}

function renderCart(cart) {
  const itemsEl = document.querySelector('.cart-drawer__items');
  const subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
  const badge = document.querySelector('[data-cart-count]');
  if (badge) {
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
  const DELIVERY_VID = 42976083968098;
  const delivLine = cart.items.find(i => i.variant_id === DELIVERY_VID);
  const subtotalEx = cart.total_price - (delivLine ? delivLine.final_line_price : 0);
  if (subtotalEl) subtotalEl.textContent = formatMoney(subtotalEx, cart.currency);
  if (!itemsEl) return;
  // Hide the 24 Hours Delivery service line from the items list — shown as the toggle instead
  const DELIVERY_VARIANT_ID = 42976083968098;
  const visibleItems = cart.items.filter(i => i.variant_id !== DELIVERY_VARIANT_ID);
  if (visibleItems.length === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.<br>The boutique is open.</div>';
    return;
  }
  itemsEl.innerHTML = visibleItems.map(i => {
    const brand = i.product_type || i.vendor || '';
    const sizeLabel = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
    return `
    <div class="cart-item" data-line-key="${i.key}">
      <div class="cart-item__image">
        ${i.image ? `<img src="${i.image}" alt="">` : ''}
      </div>
      <div>
        <div class="cart-item__brand">AUREA LUXE${brand ? ` <span class="dot">•</span> <span class="brand-name">${brand}</span>` : ''}</div>
        <div class="cart-item__name">${i.product_title}</div>
        ${sizeLabel ? `<div class="cart-item__size">${sizeLabel}</div>` : ''}
        <div class="cart-item__row">
          <div class="cart-item__qty">
            <button type="button" class="qty-btn" data-action="dec" aria-label="Decrease">−</button>
            <input type="number" class="qty-input" value="${i.quantity}" min="0" inputmode="numeric">
            <button type="button" class="qty-btn" data-action="inc" aria-label="Increase">+</button>
          </div>
          <div class="cart-item__price">${formatMoney(i.final_line_price, cart.currency)}</div>
        </div>
        <button type="button" class="cart-item__remove" data-action="remove">Remove</button>
      </div>
    </div>`;
  }).join('');
}
window.renderCart = renderCart;

function collapseAndRemove(wrap) {
  // Snap-shot height so we can animate it down
  wrap.style.maxHeight = wrap.offsetHeight + 'px';
  wrap.style.overflow = 'hidden';
  wrap.style.transition = 'max-height 200ms ease, opacity 150ms ease, padding 200ms ease, margin 200ms ease, border 200ms ease';
  // Force a reflow so the start values are committed before transition kicks in
  void wrap.offsetHeight;
  requestAnimationFrame(() => {
    wrap.style.maxHeight = '0';
    wrap.style.opacity = '0';
    wrap.style.paddingTop = '0';
    wrap.style.paddingBottom = '0';
    wrap.style.marginBottom = '0';
    wrap.style.marginTop = '0';
    wrap.style.borderBottomWidth = '0';
  });
  setTimeout(() => wrap.remove(), 230);
}

function adjustSubtotalOptimistic(deltaCents) {
  // Update subtotal everywhere — drawer + full cart page
  document.querySelectorAll('.cart-drawer__subtotal-value, .cart-page__subtotal').forEach(el => {
    const current = parseFloat((el.textContent || '').replace(/[^0-9.-]/g, '')) || 0;
    const next = Math.max(0, current * 100 + deltaCents);
    el.textContent = formatMoney(next, 'AED');
  });
}

function adjustBadgeOptimistic(delta) {
  const badge = document.querySelector('[data-cart-count]');
  if (!badge) return;
  const next = Math.max(0, parseInt(badge.textContent || '0', 10) + delta);
  badge.textContent = next;
  badge.style.display = next > 0 ? 'flex' : 'none';
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-action]');
  if (!btn) return;
  const wrap = btn.closest('.cart-item');
  if (!wrap) return;
  const key = wrap.dataset.lineKey;
  const input = wrap.querySelector('.qty-input');
  const action = btn.dataset.action;

  let qty = parseInt(input.value || '1', 10);
  if (action === 'inc') qty += 1;
  else if (action === 'dec') qty = Math.max(0, qty - 1);
  else if (action === 'remove') qty = 0;

  // Optimistic UI: update qty display, subtotal, and badge instantly
  if (action === 'remove' || qty === 0) {
    const priceCents = parseFloat((wrap.querySelector('.cart-item__price')?.textContent || '').replace(/[^0-9.-]/g, '')) * 100 || 0;
    const oldQty = parseInt(input?.value || '1', 10);
    adjustSubtotalOptimistic(-priceCents);
    adjustBadgeOptimistic(-oldQty);
    // Block re-render during the collapse animation so it stays smooth
    suppressRenderUntil = performance.now() + 260;
    collapseAndRemove(wrap);
  } else if (action === 'inc' || action === 'dec') {
    const unit = (parseFloat((wrap.querySelector('.cart-item__price')?.textContent || '').replace(/[^0-9.-]/g, '')) || 0) / parseInt(input?.value || '1', 10);
    const delta = (action === 'inc') ? 1 : -1;
    if (input) input.value = qty;
    adjustSubtotalOptimistic(delta * unit * 100);
    adjustBadgeOptimistic(delta);
    // Update visible line price too
    const priceEl = wrap.querySelector('.cart-item__price');
    if (priceEl) priceEl.textContent = formatMoney(unit * qty * 100, 'AED');
  }

  applyCartChange(key, qty);
});

let qtyDebounce;
document.addEventListener('input', (e) => {
  const input = e.target.closest('.cart-item .qty-input');
  if (!input) return;
  const wrap = input.closest('.cart-item');
  const key = wrap?.dataset.lineKey;
  if (!key) return;
  clearTimeout(qtyDebounce);
  qtyDebounce = setTimeout(() => {
    const qty = Math.max(0, parseInt(input.value || '0', 10));
    applyCartChange(key, qty);
  }, 300);
});

function formatMoney(cents, currency = 'AED') {
  const value = (cents / 100).toLocaleString('en-AE', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return currency + ' ' + value;
}

// initial badge state
window.addEventListener('DOMContentLoaded', () => refreshCart());

/* ============================================================
   Intro video overlay — show on first visit per session
   ============================================================ */
(function initIntro() {
  const KEY = 'aurea-intro-seen-v1';
  // Honor reduced-motion preference + respect previous visit
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}

  function start() {
    const overlay = document.querySelector('[data-al-intro]');
    if (!overlay) return;
    const video = overlay.querySelector('[data-al-intro-video]');
    const skipBtn = overlay.querySelector('[data-al-intro-skip]');
    if (!video || !skipBtn) return;

    // Show overlay
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    let closed = false;
    function close() {
      if (closed) return;
      closed = true;
      clearTimeout(hardTimeout);
      clearTimeout(stallTimeout);
      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');
      overlay.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      try { video.pause(); } catch (e) {}
      setTimeout(() => {
        overlay.hidden = true;
        overlay.classList.remove('is-closing');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }, 800);
    }

    // SAFETY NET 1: hard cap — never trap the user longer than 10s total
    const hardTimeout = setTimeout(close, 10000);

    // SAFETY NET 2: if video hasn't started playing within 2.5s, skip it
    let stallTimeout = setTimeout(function(){
      if (video.currentTime < 0.1) close();
    }, 2500);
    video.addEventListener('playing', function(){
      clearTimeout(stallTimeout);
    });

    // SAFETY NET 3: any load/decode error → skip immediately
    video.addEventListener('error', close);
    const srcs = video.querySelectorAll('source');
    srcs.forEach(s => s.addEventListener('error', function(){
      // only close when the LAST source has failed
      if (s === srcs[srcs.length - 1]) close();
    }));

    // Try playing muted (browsers allow muted autoplay)
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => { /* autoplay blocked — safety timeout will skip */ });
    }

    skipBtn.addEventListener('click', close);
    video.addEventListener('ended', close);
    // Esc key skip
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ============================================================
   Fade-in on scroll — product cards (& opt-in elements)
   ============================================================ */
(function initReveal() {
  // Skip for users who prefer reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.product-card, [data-al-reveal]').forEach(el => el.classList.add('is-visible'));
    return;
  }
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.product-card, [data-al-reveal]').forEach(el => el.classList.add('is-visible'));
    return;
  }

  function arm() {
    const targets = document.querySelectorAll('.product-card:not(.is-visible), [data-al-reveal]:not(.is-visible)');
    if (!targets.length) return;

    // Compute per-grid stagger: index within parent grid
    targets.forEach((el) => {
      el.classList.add('al-reveal');
      const parent = el.parentElement;
      if (parent && parent.classList.contains('product-grid')) {
        const siblings = Array.from(parent.children).filter(c => c.classList.contains('product-card'));
        const idx = siblings.indexOf(el);
        // Cap stagger so very large grids don't have huge delays
        const cappedIdx = Math.min(idx, 5);
        el.style.transitionDelay = (cappedIdx * 30) + 'ms';
      }
    });

    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }
    }, { rootMargin: '0px 0px 5% 0px', threshold: 0.01 });

    targets.forEach(t => io.observe(t));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }

  // Re-arm after AJAX content swaps (cart drawer adds, predictive search, etc.)
  document.addEventListener('al:content-updated', arm);
  // Also expose globally if other code wants to call it
  window.__alRevealRearm = arm;
})();

/* ============================================================
   24 Hours Delivery toggle — add/remove the service product from cart
   ============================================================ */
(function initDeliveryToggle() {
  function findToggles() { return document.querySelectorAll('[data-delivery-toggle]'); }

  async function getCart() {
    try { const r = await fetch('/cart.js'); return await r.json(); } catch { return null; }
  }

  function findLine(cart, variantId) {
    if (!cart || !cart.items) return null;
    const vid = parseInt(variantId, 10);
    return cart.items.find(it => it.variant_id === vid) || null;
  }

  function setState(btn, isOn, isLoading) {
    btn.classList.toggle('is-on', !!isOn);
    btn.classList.toggle('is-loading', !!isLoading);
    btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
  }

  // Hide toggle if cart has no real (non-delivery) products
  function setVisibility(btn, cart) {
    if (!cart) return;
    const deliveryId = parseInt(btn.getAttribute('data-variant-id'), 10);
    const hasRealItems = cart.items.some(i => i.variant_id !== deliveryId);
    btn.classList.toggle('is-hidden', !hasRealItems);
    if (hasRealItems) btn.removeAttribute('hidden');
    else btn.setAttribute('hidden', '');
  }

  async function syncFromCart() {
    const toggles = findToggles();
    if (!toggles.length) return;
    const cart = await getCart();
    toggles.forEach(btn => {
      const variantId = btn.getAttribute('data-variant-id');
      const line = findLine(cart, variantId);
      setState(btn, !!line, false);
      setVisibility(btn, cart);
    });
    return cart;
  }
  // Expose so other parts of theme.js can refresh visibility after cart ops
  window.__alDeliveryToggleSync = syncFromCart;

  // Update on-page subtotal labels (cart page) — drawer is handled by renderCart()
  function updateCartPageSubtotal(cart) {
    if (!cart) return;
    const sub = document.querySelector('.cart-page__subtotal');
    if (sub) sub.textContent = (typeof formatMoney === 'function')
      ? formatMoney(cart.total_price - (cart.items.find(i=>i.variant_id===42976083968098)?.final_line_price||0), cart.currency)
      : 'AED ' + ((cart.total_price - (cart.items.find(i=>i.variant_id===42976083968098)?.final_line_price||0)) / 100).toFixed(2);
  }

  async function toggleDelivery(btn) {
    if (btn.classList.contains('is-loading')) return;
    const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    const wasOn = btn.classList.contains('is-on');
    // Optimistic visual flip — INSTANT feedback (no network wait)
    setState(btn, !wasOn, true);

    // Single round-trip: /cart/update.js sets variant qty directly (0 = remove, 1 = add).
    // Returns the updated cart with totals so no follow-up fetch needed.
    let updatedCart = null;
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: wasOn ? 0 : 1 } }),
      });
      if (!res.ok) throw new Error('cart update failed: ' + res.status);
      updatedCart = await res.json();
    } catch (err) {
      console.error('delivery toggle failed', err);
      setState(btn, wasOn, false);   // revert
      return;
    }

    // Sync ALL toggles' on/off + visibility + clear loading
    findToggles().forEach(b => {
      const v = b.getAttribute('data-variant-id');
      setState(b, !!findLine(updatedCart, v), false);
      setVisibility(b, updatedCart);
    });
    // Update cart drawer items + drawer subtotal (uses the cart we already have)
    if (typeof window.renderCart === 'function') {
      try { window.renderCart(updatedCart); } catch {}
    } else if (typeof window.refreshCart === 'function') {
      try { window.refreshCart(); } catch {}
    }
    // Update main cart-page subtotal
    updateCartPageSubtotal(updatedCart);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-delivery-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggleDelivery(btn);
  });

  // Sync state on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromCart);
  } else {
    syncFromCart();
  }

  // Re-sync after cart updates (other adds, qty changes, etc.)
  document.addEventListener('al:cart-updated', syncFromCart);
})();

// ---- Fade-up on scroll into view (any .al-fade-up element) ----
(function(){
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting){
        entry.target.classList.add('al-fade-up--in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
  function arm(){
    document.querySelectorAll('.al-fade-up:not(.al-fade-up--armed)').forEach(el => {
      el.classList.add('al-fade-up--armed');
      io.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', arm);
  setTimeout(arm, 200);
  setTimeout(arm, 1000);
})();

// ---- Track last listing URL (for PDP back button) ----
(function(){
  function isListing(){
    const p = location.pathname;
    return !/\/products\//.test(p) && !/^\/cart/.test(p) && !/^\/checkouts?/.test(p);
  }
  function save(){
    if (isListing()) {
      try { sessionStorage.setItem('al:lastListing', location.href); } catch {}
    }
  }
  document.addEventListener('DOMContentLoaded', save);
  window.addEventListener('pageshow', save);
})();

// ---- Search history (recent searches as chips) ----
(function(){
  const KEY = 'al:searchHistory';
  function getHist(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } }
  function pushHist(q){
    q = (q || '').trim();
    if (q.length < 2) return;
    let h = getHist().filter(x => x.toLowerCase() !== q.toLowerCase());
    h.unshift(q);
    h = h.slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify(h)); } catch {}
  }
  function clearHist(){
    try { localStorage.removeItem(KEY); } catch {}
    renderChips();
  }
  function renderChips(){
    const results = document.querySelector('[data-search-results]');
    const input = document.querySelector('[data-search-input]');
    if (!results || !input) return;
    if (input.value.trim().length >= 2) return; // typing already
    const h = getHist();
    if (h.length === 0) { results.innerHTML = ''; return; }
    const chipsHtml = h.map(q => `<button type="button" class="al-search-chip" data-history-q="${q.replace(/"/g,'&quot;')}">${q}</button>`).join('');
    results.innerHTML = `
      <div class="al-search-history" style="grid-column:1/-1;">
        <div class="al-search-history__head">
          <span class="al-search-history__label">Recent searches</span>
          <button type="button" class="al-search-history__clear" data-history-clear>Clear</button>
        </div>
        <div class="al-search-history__chips">${chipsHtml}</div>
      </div>`;
  }
  // Show chips when overlay opens with empty input
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) {
      setTimeout(renderChips, 80);
    }
    const chip = e.target.closest('[data-history-q]');
    if (chip) {
      const input = document.querySelector('[data-search-input]');
      if (input) {
        input.value = chip.dataset.historyQ;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      }
      return;
    }
    if (e.target.closest('[data-history-clear]')) {
      clearHist();
    }
    // Save query when user clicks a search-result product
    const card = e.target.closest('[data-search-results] a.product-card');
    if (card) {
      const input = document.querySelector('[data-search-input]');
      if (input) pushHist(input.value);
    }
  });
  // Save on form submit (Enter)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (input) pushHist(input.value);
  });
  // Save when user clears input (so prior search persists)
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-search-input]');
    if (!input) return;
    // When input goes back to empty, re-render chips
    if (input.value.trim().length === 0) renderChips();
  });
})();

// ---- Pre-warm PDP page + image on hover/touch of product card ----
(function(){
  function bumpImg(src){
    if (!src) return null;
    // Pattern 1: _600x600 suffix → use as-is (already a smaller size, swap to 600)
    if (/_\d+x\d+/.test(src)) return src.replace(/_\d+x\d+/, '_600x600');
    // Pattern 2: ?width=N query → set to width=600
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1600');
    return src;
  }
  function preloadFromCard(card){
    if (card.__preloaded) return;
    card.__preloaded = true;
    const img = card.querySelector('img');
    const imgSrc = bumpImg(img?.currentSrc || img?.src || '');
    // Preload the image (same size as PDP first paint)
    if (imgSrc) {
      const lnkI = document.createElement('link');
      lnkI.rel = 'preload';
      lnkI.as = 'image';
      lnkI.href = imgSrc;
      try { lnkI.fetchPriority = 'high'; } catch {}
      document.head.appendChild(lnkI);
    }
    // Prefetch the PDP HTML so server-rendered page is in cache
    const href = card.getAttribute('href');
    if (href && /\/products\//.test(href)) {
      const lnkP = document.createElement('link');
      lnkP.rel = 'prefetch';
      lnkP.as = 'document';
      lnkP.href = href;
      document.head.appendChild(lnkP);
    }
  }
  document.addEventListener('mouseover', (e) => {
    const card = e.target.closest('a.product-card');
    if (card) preloadFromCard(card);
  }, { passive: true });
  document.addEventListener('touchstart', (e) => {
    const card = e.target.closest('a.product-card');
    if (card) preloadFromCard(card);
  }, { passive: true });
})();

// ---- al-media-unlock: force video playback inside in-app browsers (Instagram / Facebook / TikTok webviews) ----
(function(){
  function playAll(){
    var vids = document.querySelectorAll('video');
    vids.forEach(function(v){
      try {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('muted','');
        v.setAttribute('playsinline','');
        v.setAttribute('webkit-playsinline','');
        // Scroll-cinematic videos are scrubbed, not auto-looped — prime seeking then pause
        var isScrub = v.closest && v.closest('.al-scroll-cinematic');
        var p = v.play();
        if (p && p.then){
          p.then(function(){
            if (isScrub) { try { v.pause(); } catch(e){} }
          }).catch(function(){});
        }
      } catch(e){}
    });
  }
  // Try immediately + after load
  document.addEventListener('DOMContentLoaded', playAll);
  window.addEventListener('load', playAll);
  // In-app webviews block autoplay until a gesture — unlock on the very first interaction
  var unlocked = false;
  function unlock(){
    if (unlocked) return;
    unlocked = true;
    playAll();
    // second pass shortly after (metadata may still be loading)
    setTimeout(playAll, 300);
    setTimeout(playAll, 1200);
    ['touchstart','pointerdown','click','keydown','scroll'].forEach(function(ev){
      window.removeEventListener(ev, unlock, true);
    });
  }
  ['touchstart','pointerdown','click','keydown','scroll'].forEach(function(ev){
    window.addEventListener(ev, unlock, { capture:true, passive:true });
  });
  // Re-check when tab becomes visible (webview resume)
  document.addEventListener('visibilitychange', function(){ if(!document.hidden) playAll(); });
})();

// ---- al-tactile: gold ripple + instant page-fade navigation ----
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Gold ripple from the exact click point
  var RIPPLE_SEL = '.product-card, .btn, .btn-ghost, .pagination a, .al-search-chip';
  document.addEventListener('pointerdown', function(e){
    if (reduced) return;
    var host = e.target.closest(RIPPLE_SEL);
    if (!host) return;
    host.classList.add('al-ripple-host');
    var rect = host.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height);
    var r = document.createElement('span');
    r.className = 'al-ripple';
    r.style.width = r.style.height = size + 'px';
    r.style.left = (e.clientX - rect.left - size/2) + 'px';
    r.style.top  = (e.clientY - rect.top  - size/2) + 'px';
    host.appendChild(r);
    setTimeout(function(){ r.remove(); }, 650);
  }, { passive: true });

  // 2) True zero-delay navigation: prerender product pages in the background
  //    (Chrome/Edge/Samsung Speculation Rules — page is READY before the click lands)
  try {
    var sr = document.createElement('script');
    sr.type = 'speculationrules';
    sr.textContent = JSON.stringify({
      prerender: [{ where: { href_matches: '/products/*' }, eagerness: 'moderate' }],
      prefetch:  [{ where: { href_matches: '/collections/*' }, eagerness: 'moderate' }]
    });
    document.head.appendChild(sr);
  } catch(e){}



  // 3) Gentle fade-in on arrival (content paints immediately, just eases in)
  function enter(){
    document.body.classList.remove('al-page-exit');
    document.body.classList.add('al-page-enter');
    setTimeout(function(){ document.body.classList.remove('al-page-enter'); }, 240);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enter);
  } else { enter(); }
  window.addEventListener('pageshow', function(ev){
    if (ev.persisted) enter();
    else document.body.classList.remove('al-page-exit');
  });
})();
